import { render } from "./InputPage.vue?vue&type=template&id=6a7effb8&ts=true"
import script from "./InputPage.vue?vue&type=script&lang=ts"
export * from "./InputPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QuanLy_Spa/QuanLy_Spa_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__